export const MISC_T = {
  fr: {
    checkout_title: 'Checkout',
    checkout_subscription: 'Abonnement',
    checkout_domain: (d) => `Domaine ${d}`,
    checkout_invalid_type: 'Type de checkout invalide.',
    checkout_no_pack: 'Aucun pack sélectionné.',
    checkout_receipt_pending: 'Cette opération peut prendre un certain temps. Si votre pack n\'est pas mis à niveau dans un délai maximum de 3 jours, veuillez contacter le support.',
    checkout_back_kiostore: 'Retour à KIOSTORE',
    checkout_recap: 'Récapitulatif',
    checkout_domain_label: 'Domaine',
    checkout_pack_label: 'Pack',
    checkout_billing_annual: 'Facturation annuelle',
    checkout_billing_monthly: 'Facturation mensuelle',
    checkout_per_month: '/ mois',
    checkout_per_year: '/ an',
    checkout_promo_title: 'Code promo',
    checkout_promo_apply: 'Appliquer',
    checkout_promo_placeholder: 'Ex: EE',
    checkout_promo_invalid: 'Code promo invalide',
    checkout_promo_applied: (code) => `Code « ${code} » appliqué.`,
    checkout_payment_title: 'Mode de paiement',
    checkout_pay_cib: 'CIB / Dahabia',
    checkout_pay_cib_desc: 'Paiement sécurisé via SATIM',
    checkout_pay_receipt: 'Paiement par reçu',
    checkout_pay_receipt_desc: 'Virement bancaire avec preuve de paiement',
    checkout_bank_title: 'Coordonnées bancaires',
    checkout_bank_trust: 'Banque Trust',
    checkout_bank_baridimob: 'Baridimob',
    checkout_bank_ccp: 'Virement CCP',
    checkout_receipt_instructions: 'Scannez le reçu du virement que vous avez effectué ou faites une capture d\'écran et téléchargez-le ci-dessous pour fournir une preuve de paiement.',
    checkout_receipt_alt: 'Reçu de paiement',
    checkout_remove: 'Supprimer',
    checkout_pay_cib_btn: 'Payer par CIB',
    checkout_send_receipt: 'Envoyer le reçu',
    checkout_err_pack: 'Pack introuvable.',
    checkout_err_domain: 'Domaine introuvable.',
    checkout_err_store: 'Sélectionnez une boutique avant d\'acheter un domaine.',
    checkout_err_receipt: 'Téléchargez le reçu de virement pour continuer.',
    checkout_err_payment: 'Paiement impossible',
    checkout_dropzone_hint: 'PNG, JPG ou capture d\'écran',
    checkout_step_recap: 'Récapitulatif',
    checkout_step_payment: 'Paiement',
    checkout_step_confirm: 'Confirmation',
    checkout_step_receipt: 'Reçu',
    checkout_step_verification: 'Vérification',
    checkout_step_recap_sub: 'Vérifiez votre commande avant de continuer.',
    checkout_step_payment_sub: 'Choisissez comment vous souhaitez payer.',
    checkout_step_confirm_sub: 'Finalisez votre paiement.',
    checkout_step_confirm_cib_sub: 'Vous serez redirigé vers la plateforme SATIM pour payer en toute sécurité.',
    checkout_previous: 'Précédent',
    checkout_back: 'Retour',
    checkout_receipt_success_title: 'Reçu envoyé avec succès',
    checkout_receipt_success_sub: 'Votre demande de mise à niveau est en cours de vérification.',
    checkout_receipt_status_pending: 'En attente de validation',
    checkout_receipt_next_title: 'Prochaines étapes',
    checkout_receipt_step_1: 'Notre équipe vérifie votre reçu de virement',
    checkout_receipt_go_admin: 'Accéder à votre admin',
    checkout_receipt_support: 'Une question ? Contactez le support depuis votre tableau de bord.',
    checkout_payment_checking: 'Vérification du paiement en cours…',
    checkout_payment_verify_error: 'Impossible de vérifier le paiement',
    checkout_cib_verifying_sub: 'Nous interrogeons la plateforme SATIM pour confirmer votre transaction.',
    checkout_cib_success_title: 'Paiement confirmé',
    checkout_cib_success_sub: 'Votre abonnement a été mis à jour avec succès.',
    checkout_cib_failed_title: 'Paiement refusé',
    checkout_cib_failed_sub: 'La transaction a été refusée ou annulée. Vous pouvez réessayer ou choisir un autre plan.',
    checkout_cib_detail_amount: 'Montant',
    checkout_cib_detail_order: 'N° commande',
    checkout_cib_detail_auth: 'Autorisation',
    checkout_cib_detail_date: 'Date',
    checkout_cib_detail_description: 'Description',
    checkout_cib_detail_satim_id: 'ID transaction',
    checkout_cib_detail_method: 'Mode de paiement',
    checkout_cib_card: 'Carte CIB',
    checkout_cib_email_modal_title: 'Envoyer le reçu par email',
    checkout_cib_email_placeholder: 'Adresse email',
    checkout_cib_email_send: 'Envoyer',
    checkout_cib_email_sent: 'Reçu envoyé avec succès',
    checkout_cib_email_error: 'Impossible d\'envoyer le reçu',
    checkout_cib_receipt_error: 'Impossible de generer le recu PDF',
    checkout_cib_print_blocked: 'Autorisez les pop-ups pour imprimer le recu',
    checkout_invoice_title: 'FACTURE',
    checkout_invoice_store: 'Boutique',
    checkout_invoice_product: 'Produit',
    checkout_invoice_type: 'Type',
    checkout_invoice_period: 'Periode',
    checkout_invoice_amount: 'Montant',
    checkout_invoice_promo: 'Code promo',
    checkout_invoice_subtotal: 'Sous-total',
    checkout_invoice_discount: 'Reduction',
    checkout_invoice_total: 'Total paye',
    checkout_invoice_payment: 'Paiement CIB',
    checkout_invoice_paid: 'Paye',
    checkout_invoice_signature: 'KIO - SARL NEO FINTECH',
    checkout_invoice_website: 'www.kiostore.net',
    checkout_invoice_period_monthly: 'Mensuel',
    checkout_invoice_period_annual: 'Annuel',
    checkout_cib_email_required: 'Saisissez une adresse email',
    checkout_cib_transaction_rejected: 'Transaction refusée',
    checkout_cib_print: 'Imprimer',
    checkout_cib_download: 'Télécharger',
    checkout_cib_email: 'Envoyer par email',
    checkout_cib_go_admin: 'Accéder à votre admin',
    checkout_cib_back_pricing: 'Retour aux tarifs',
    checkout_cib_retry: 'Réessayer le paiement',
    checkout_cib_terms_modal_title: 'Conditions de paiement CIB',
    checkout_cib_terms_modal_desc: 'Avant de procéder au paiement sécurisé via SATIM, veuillez accepter les conditions générales de vente de KIO.',
    checkout_cib_terms_accept: 'J\'ai lu et j\'accepte les',
    checkout_cib_terms_link: 'conditions générales de vente',
    checkout_cib_terms_confirm: 'Confirmer et payer',
    checkout_cib_terms_error: 'Vous devez accepter les conditions d\'utilisation pour continuer.',
    store_pages_title: 'Pages',
    store_pages_sub: 'Pages statiques de votre boutique (À propos, Contact, CGV…)',
    store_pages_add: 'Ajouter une page',
    store_pages_edit: 'Modifier la page',
    store_pages_delete: 'Supprimer la page',
    store_pages_loading: 'Chargement…',
    store_pages_back: 'Pages',
    store_pages_back_store: 'KIOSTORE',
    store_pages_search: 'Rechercher une page',
    store_pages_empty_heading: 'Aucune page',
    store_pages_empty_body: 'Créez des pages comme À propos, Contact ou Politique de retour.',
    store_pages_col_title: 'Titre',
    store_pages_col_url: 'URL',
    store_pages_col_visibility: 'Visibilité',
    store_pages_col_updated: 'Mise à jour',
    store_pages_delete_confirm: (title) => `Supprimer la page « ${title} » ?`,
    store_pages_err_load: 'Impossible de charger les pages',
    store_pages_err_delete: 'Impossible de supprimer la page',
    store_pages_err_load_one: 'Impossible de charger la page',
    store_pages_err_save: 'Impossible d\'enregistrer la page',
    store_pages_saved: 'Page enregistrée',
    store_pages_field_title: 'Titre de la page',
    store_pages_visibility: 'Visibilité',
    store_pages_slug: 'URL de la page',
    store_pages_content: 'Contenu',
    store_pages_system: 'Page système',
    store_pages_title_placeholder: 'À propos',
    carrier_not_found: 'Transporteur introuvable',
    carrier_zones_title: (name) => `Zones — ${name}`,
    carrier_zones_sub: 'Visibilité domicile / pickup au checkout par wilaya et commune',
    ecotrack_sub: (host) => `Gestion des envois — ${host}`,
    noest_title: 'NOEST',
    noest_sub: 'Gestion des envois — app.noest-dz.com',
    order_title: (id) => `Commande — ${id}`,
    label_title: (id) => `Étiquette — ${id}`,
    delete_order: 'Supprimer la commande ?',
    order_created: 'Commande créée avec succès !',
    error: 'Erreur',
    invalid_api: 'Identifiants API invalides',
    not_configured: 'Intégration non configurée',
    invalid_token: 'Token API invalide',
    onboarding_create: 'Créer ma boutique',
    onboarding_step: (n, total) => `Étape ${n} sur ${total}`,
    onboarding_store_name: 'Nom de la boutique',
    onboarding_continue: 'Continuer',
    onboarding_finish: 'Terminer',
    tab_orders: 'Commandes',
    tab_labels: 'Étiquettes',
    tab_settings: 'Paramètres',
    tab_sync: 'Synchronisation',
    save: 'Enregistrer',
    cancel: 'Annuler',
    close: 'Fermer',
    delete_btn: 'Supprimer',
    refresh: 'Actualiser',
    export: 'Exporter',
    loading: 'Chargement…',
    visible: 'Visible',
    hidden: 'Masquée',
    onboarding_stage_create: 'Création de votre boutique',
    onboarding_stage_domain: 'Configuration du domaine',
    onboarding_stage_options: 'Paramétrage des options',
    onboarding_stage_ready: 'Boutique prête au décollage',
  },
  en: {
    checkout_title: 'Checkout',
    checkout_subscription: 'Subscription',
    checkout_domain: (d) => `Domain ${d}`,
    checkout_invalid_type: 'Invalid checkout type.',
    checkout_no_pack: 'No plan selected.',
    checkout_receipt_pending: 'This may take some time. If your plan is not upgraded within 3 days, please contact support.',
    checkout_back_kiostore: 'Back to KIOSTORE',
    checkout_recap: 'Summary',
    checkout_domain_label: 'Domain',
    checkout_pack_label: 'Plan',
    checkout_billing_annual: 'Annual billing',
    checkout_billing_monthly: 'Monthly billing',
    checkout_per_month: '/ month',
    checkout_per_year: '/ year',
    checkout_promo_title: 'Promo code',
    checkout_promo_apply: 'Apply',
    checkout_promo_placeholder: 'E.g. EE',
    checkout_promo_invalid: 'Invalid promo code',
    checkout_promo_applied: (code) => `Code "${code}" applied.`,
    checkout_payment_title: 'Payment method',
    checkout_pay_cib: 'CIB / Dahabia',
    checkout_pay_cib_desc: 'Secure payment via SATIM',
    checkout_pay_receipt: 'Bank transfer receipt',
    checkout_pay_receipt_desc: 'Bank transfer with proof of payment',
    checkout_bank_title: 'Bank details',
    checkout_bank_trust: 'Banque Trust',
    checkout_bank_baridimob: 'Baridimob',
    checkout_bank_ccp: 'CCP transfer',
    checkout_receipt_instructions: 'Scan the transfer receipt or take a screenshot and upload it below as proof of payment.',
    checkout_receipt_alt: 'Payment receipt',
    checkout_remove: 'Remove',
    checkout_pay_cib_btn: 'Pay with CIB',
    checkout_send_receipt: 'Submit receipt',
    checkout_err_pack: 'Plan not found.',
    checkout_err_domain: 'Domain not found.',
    checkout_err_store: 'Select a store before purchasing a domain.',
    checkout_err_receipt: 'Upload the transfer receipt to continue.',
    checkout_err_payment: 'Payment failed',
    checkout_dropzone_hint: 'PNG, JPG or screenshot',
    checkout_step_recap: 'Summary',
    checkout_step_payment: 'Payment',
    checkout_step_confirm: 'Confirmation',
    checkout_step_receipt: 'Receipt',
    checkout_step_verification: 'Verification',
    checkout_step_recap_sub: 'Review your order before continuing.',
    checkout_step_payment_sub: 'Choose how you want to pay.',
    checkout_step_confirm_sub: 'Complete your payment.',
    checkout_step_confirm_cib_sub: 'You will be redirected to SATIM to pay securely.',
    checkout_previous: 'Previous',
    checkout_back: 'Back',
    checkout_receipt_success_title: 'Receipt submitted successfully',
    checkout_receipt_success_sub: 'Your upgrade request is being reviewed.',
    checkout_receipt_status_pending: 'Pending validation',
    checkout_receipt_next_title: 'What happens next',
    checkout_receipt_step_1: 'Our team verifies your bank transfer receipt',
    checkout_receipt_go_admin: 'Go to your admin',
    checkout_receipt_support: 'Questions? Contact support from your dashboard.',
    checkout_payment_checking: 'Verifying payment…',
    checkout_payment_verify_error: 'Unable to verify payment',
    checkout_cib_verifying_sub: 'We are checking your transaction with the SATIM platform.',
    checkout_cib_success_title: 'Payment confirmed',
    checkout_cib_success_sub: 'Your subscription has been upgraded successfully.',
    checkout_cib_failed_title: 'Payment declined',
    checkout_cib_failed_sub: 'The transaction was declined or cancelled. You can try again or choose another plan.',
    checkout_cib_detail_amount: 'Amount',
    checkout_cib_detail_order: 'Order no.',
    checkout_cib_detail_auth: 'Authorization',
    checkout_cib_detail_date: 'Date',
    checkout_cib_detail_description: 'Description',
    checkout_cib_detail_satim_id: 'Transaction ID',
    checkout_cib_detail_method: 'Payment method',
    checkout_cib_card: 'CIB card',
    checkout_cib_email_modal_title: 'Send receipt by email',
    checkout_cib_email_placeholder: 'Email address',
    checkout_cib_email_send: 'Send',
    checkout_cib_email_sent: 'Receipt sent successfully',
    checkout_cib_email_error: 'Unable to send receipt',
    checkout_cib_receipt_error: 'Unable to generate PDF receipt',
    checkout_cib_print_blocked: 'Allow pop-ups to print the receipt',
    checkout_invoice_title: 'INVOICE',
    checkout_invoice_store: 'Store',
    checkout_invoice_product: 'Product',
    checkout_invoice_type: 'Type',
    checkout_invoice_period: 'Period',
    checkout_invoice_amount: 'Amount',
    checkout_invoice_promo: 'Promo code',
    checkout_invoice_subtotal: 'Subtotal',
    checkout_invoice_discount: 'Discount',
    checkout_invoice_total: 'Total paid',
    checkout_invoice_payment: 'CIB payment',
    checkout_invoice_paid: 'Paid',
    checkout_invoice_signature: 'KIO - SARL NEO FINTECH',
    checkout_invoice_website: 'www.kiostore.net',
    checkout_invoice_period_monthly: 'Monthly',
    checkout_invoice_period_annual: 'Annual',
    checkout_cib_email_required: 'Enter an email address',
    checkout_cib_transaction_rejected: 'Transaction declined',
    checkout_cib_print: 'Print',
    checkout_cib_download: 'Download',
    checkout_cib_email: 'Send by email',
    checkout_cib_go_admin: 'Go to your admin',
    checkout_cib_back_pricing: 'Back to pricing',
    checkout_cib_retry: 'Try payment again',
    checkout_cib_terms_modal_title: 'CIB payment terms',
    checkout_cib_terms_modal_desc: 'Before proceeding to secure payment via SATIM, please accept the KIO Terms of Sale.',
    checkout_cib_terms_accept: 'I have read and accept the',
    checkout_cib_terms_link: 'Terms of Sale',
    checkout_cib_terms_confirm: 'Confirm and pay',
    checkout_cib_terms_error: 'You must accept the Terms of Service to continue.',
    store_pages_title: 'Pages',
    store_pages_sub: 'Static store pages (About, Contact, Terms…)',
    store_pages_add: 'Add page',
    store_pages_edit: 'Edit page',
    store_pages_delete: 'Delete page',
    store_pages_loading: 'Loading…',
    store_pages_back: 'Pages',
    store_pages_back_store: 'KIOSTORE',
    store_pages_search: 'Search a page',
    store_pages_empty_heading: 'No pages',
    store_pages_empty_body: 'Create pages like About, Contact or Return Policy.',
    store_pages_col_title: 'Title',
    store_pages_col_url: 'URL',
    store_pages_col_visibility: 'Visibility',
    store_pages_col_updated: 'Updated',
    store_pages_delete_confirm: (title) => `Delete page « ${title} »?`,
    store_pages_err_load: 'Unable to load pages',
    store_pages_err_delete: 'Unable to delete page',
    store_pages_err_load_one: 'Unable to load page',
    store_pages_err_save: 'Unable to save page',
    store_pages_saved: 'Page saved',
    store_pages_field_title: 'Page title',
    store_pages_visibility: 'Visibility',
    store_pages_slug: 'Page URL',
    store_pages_content: 'Content',
    store_pages_system: 'System page',
    store_pages_title_placeholder: 'About',
    carrier_not_found: 'Carrier not found',
    carrier_zones_title: (name) => `Zones — ${name}`,
    carrier_zones_sub: 'Home / pickup visibility at checkout by wilaya and commune',
    ecotrack_sub: (host) => `Shipment management — ${host}`,
    noest_title: 'NOEST',
    noest_sub: 'Shipment management — app.noest-dz.com',
    order_title: (id) => `Order — ${id}`,
    label_title: (id) => `Label — ${id}`,
    delete_order: 'Delete order?',
    order_created: 'Order created successfully!',
    error: 'Error',
    invalid_api: 'Invalid API credentials',
    not_configured: 'Integration not configured',
    invalid_token: 'Invalid API token',
    onboarding_create: 'Create my store',
    onboarding_step: (n, total) => `Step ${n} of ${total}`,
    onboarding_store_name: 'Store name',
    onboarding_continue: 'Continue',
    onboarding_finish: 'Finish',
    tab_orders: 'Orders',
    tab_labels: 'Labels',
    tab_settings: 'Settings',
    tab_sync: 'Sync',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    delete_btn: 'Delete',
    refresh: 'Refresh',
    export: 'Export',
    loading: 'Loading…',
    visible: 'Visible',
    hidden: 'Hidden',
    onboarding_stage_create: 'Creating your store',
    onboarding_stage_domain: 'Domain configuration',
    onboarding_stage_options: 'Setting up options',
    onboarding_stage_ready: 'Store ready to launch',
  },
  ar: {
    checkout_title: 'الدفع',
    checkout_subscription: 'الاشتراك',
    checkout_domain: (d) => `النطاق ${d}`,
    checkout_invalid_type: 'نوع الدفع غير صالح.',
    checkout_no_pack: 'لم يتم اختيار خطة.',
    checkout_receipt_pending: 'قد تستغرق هذه العملية بعض الوقت. إذا لم يتم ترقية خطتك خلال 3 أيام كحد أقصى، يرجى الاتصال بالدعم.',
    checkout_back_kiostore: 'العودة إلى KIOSTORE',
    checkout_recap: 'الملخص',
    checkout_domain_label: 'النطاق',
    checkout_pack_label: 'الخطة',
    checkout_billing_annual: 'فوترة سنوية',
    checkout_billing_monthly: 'فوترة شهرية',
    checkout_per_month: '/ شهر',
    checkout_per_year: '/ سنة',
    checkout_promo_title: 'رمز ترويجي',
    checkout_promo_apply: 'تطبيق',
    checkout_promo_placeholder: 'مثال: EE',
    checkout_promo_invalid: 'رمز ترويجي غير صالح',
    checkout_promo_applied: (code) => `تم تطبيق الرمز « ${code} ».`,
    checkout_payment_title: 'طريقة الدفع',
    checkout_pay_cib: 'CIB / ذهبية',
    checkout_pay_cib_desc: 'دفع آمن عبر SATIM',
    checkout_pay_receipt: 'الدفع بإيصال تحويل',
    checkout_pay_receipt_desc: 'تحويل بنكي مع إثبات الدفع',
    checkout_bank_title: 'التفاصيل البنكية',
    checkout_bank_trust: 'Banque Trust',
    checkout_bank_baridimob: 'Baridimob',
    checkout_bank_ccp: 'تحويل CCP',
    checkout_receipt_instructions: 'امسح إيصال التحويل ضوئياً أو التقط لقطة شاشة وحمّله أدناه كإثبات للدفع.',
    checkout_receipt_alt: 'إيصال الدفع',
    checkout_remove: 'إزالة',
    checkout_pay_cib_btn: 'الدفع بـ CIB',
    checkout_send_receipt: 'إرسال الإيصال',
    checkout_err_pack: 'الخطة غير موجودة.',
    checkout_err_domain: 'النطاق غير موجود.',
    checkout_err_store: 'اختر متجراً قبل شراء نطاق.',
    checkout_err_receipt: 'حمّل إيصال التحويل للمتابعة.',
    checkout_err_payment: 'تعذر إتمام الدفع',
    checkout_dropzone_hint: 'PNG أو JPG أو لقطة شاشة',
    checkout_step_recap: 'الملخص',
    checkout_step_payment: 'الدفع',
    checkout_step_confirm: 'التأكيد',
    checkout_step_receipt: 'الإيصال',
    checkout_step_verification: 'التحقق',
    checkout_step_recap_sub: 'راجع طلبك قبل المتابعة.',
    checkout_step_payment_sub: 'اختر طريقة الدفع.',
    checkout_step_confirm_sub: 'أكمل عملية الدفع.',
    checkout_step_confirm_cib_sub: 'سيتم توجيهك إلى منصة SATIM للدفع بأمان.',
    checkout_previous: 'السابق',
    checkout_back: 'رجوع',
    checkout_receipt_success_title: 'تم إرسال الإيصال بنجاح',
    checkout_receipt_success_sub: 'طلب الترقية قيد المراجعة.',
    checkout_receipt_status_pending: 'في انتظار التحقق',
    checkout_receipt_next_title: 'الخطوات التالية',
    checkout_receipt_step_1: 'يقوم فريقنا بالتحقق من إيصال التحويل',
    checkout_receipt_go_admin: 'الوصول إلى لوحة التحكم',
    checkout_receipt_support: 'لديك سؤال؟ تواصل مع الدعم من لوحة التحكم.',
    checkout_payment_checking: 'جار التحقق من الدفع…',
    checkout_payment_verify_error: 'تعذر التحقق من الدفع',
    checkout_cib_verifying_sub: 'نتحقق من معاملتك عبر منصة SATIM.',
    checkout_cib_success_title: 'تم تأكيد الدفع',
    checkout_cib_success_sub: 'تم ترقية اشتراكك بنجاح.',
    checkout_cib_failed_title: 'تم رفض الدفع',
    checkout_cib_failed_sub: 'تم رفض المعاملة أو إلغاؤها. يمكنك المحاولة مرة أخرى أو اختيار خطة أخرى.',
    checkout_cib_detail_amount: 'المبلغ',
    checkout_cib_detail_order: 'رقم الطلب',
    checkout_cib_detail_auth: 'التفويض',
    checkout_cib_detail_date: 'التاريخ',
    checkout_cib_detail_description: 'الوصف',
    checkout_cib_detail_satim_id: 'معرّف المعاملة',
    checkout_cib_detail_method: 'طريقة الدفع',
    checkout_cib_card: 'بطاقة CIB',
    checkout_cib_email_modal_title: 'إرسال الإيصال بالبريد',
    checkout_cib_email_placeholder: 'البريد الإلكتروني',
    checkout_cib_email_send: 'إرسال',
    checkout_cib_email_sent: 'تم إرسال الإيصال بنجاح',
    checkout_cib_email_error: 'تعذر إرسال الإيصال',
    checkout_cib_receipt_error: 'تعذر إنشاء إيصال PDF',
    checkout_cib_print_blocked: 'اسمح بالنوافذ المنبثقة للطباعة',
    checkout_invoice_title: 'فاتورة',
    checkout_invoice_store: 'المتجر',
    checkout_invoice_product: 'المنتج',
    checkout_invoice_type: 'النوع',
    checkout_invoice_period: 'الفترة',
    checkout_invoice_amount: 'المبلغ',
    checkout_invoice_promo: 'رمز ترويجي',
    checkout_invoice_subtotal: 'المجموع الفرعي',
    checkout_invoice_discount: 'التخفيض',
    checkout_invoice_total: 'المجموع المدفوع',
    checkout_invoice_payment: 'دفع CIB',
    checkout_invoice_paid: 'مدفوع',
    checkout_invoice_signature: 'KIO - SARL NEO FINTECH',
    checkout_invoice_website: 'www.kiostore.net',
    checkout_invoice_period_monthly: 'شهري',
    checkout_invoice_period_annual: 'سنوي',
    checkout_cib_email_required: 'أدخل بريداً إلكترونياً',
    checkout_cib_transaction_rejected: 'تم رفض المعاملة',
    checkout_cib_print: 'طباعة',
    checkout_cib_download: 'تنزيل',
    checkout_cib_email: 'إرسال بالبريد',
    checkout_cib_go_admin: 'الوصول إلى لوحة التحكم',
    checkout_cib_back_pricing: 'العودة إلى الأسعار',
    checkout_cib_retry: 'إعادة المحاولة',
    checkout_cib_terms_modal_title: 'شروط الدفع CIB',
    checkout_cib_terms_modal_desc: 'قبل المتابعة إلى الدفع الآمن عبر SATIM، يرجى قبول الشروط العامة للبيع لـ KIO.',
    checkout_cib_terms_accept: 'لقد قرأت وأوافق على',
    checkout_cib_terms_link: 'الشروط العامة للبيع',
    checkout_cib_terms_confirm: 'تأكيد والدفع',
    checkout_cib_terms_error: 'يجب عليك قبول شروط الاستخدام للمتابعة.',
    store_pages_title: 'الصفحات',
    store_pages_sub: 'صفحات ثابتة لمتجرك (من نحن، اتصل بنا، الشروط…)',
    store_pages_add: 'إضافة صفحة',
    store_pages_edit: 'تعديل الصفحة',
    store_pages_delete: 'حذف الصفحة',
    store_pages_loading: 'جار التحميل…',
    store_pages_back: 'الصفحات',
    store_pages_back_store: 'KIOSTORE',
    store_pages_search: 'بحث عن صفحة',
    store_pages_empty_heading: 'لا صفحات',
    store_pages_empty_body: 'أنشئ صفحات مثل من نحن أو اتصل بنا أو سياسة الإرجاع.',
    store_pages_col_title: 'العنوان',
    store_pages_col_url: 'الرابط',
    store_pages_col_visibility: 'الظهور',
    store_pages_col_updated: 'آخر تحديث',
    store_pages_delete_confirm: (title) => `حذف الصفحة « ${title} »؟`,
    store_pages_err_load: 'تعذر تحميل الصفحات',
    store_pages_err_delete: 'تعذر حذف الصفحة',
    store_pages_err_load_one: 'تعذر تحميل الصفحة',
    store_pages_err_save: 'تعذر حفظ الصفحة',
    store_pages_saved: 'تم حفظ الصفحة',
    store_pages_field_title: 'عنوان الصفحة',
    store_pages_visibility: 'الظهور',
    store_pages_slug: 'رابط الصفحة',
    store_pages_content: 'المحتوى',
    store_pages_system: 'صفحة نظام',
    store_pages_title_placeholder: 'من نحن',
    carrier_not_found: 'شركة التوصيل غير موجودة',
    carrier_zones_title: (name) => `المناطق — ${name}`,
    carrier_zones_sub: 'ظهور التوصيل للمنزل / الاستلام عند الدفع حسب الولاية والبلدية',
    ecotrack_sub: (host) => `إدارة الشحنات — ${host}`,
    noest_title: 'NOEST',
    noest_sub: 'إدارة الشحنات — app.noest-dz.com',
    order_title: (id) => `الطلب — ${id}`,
    label_title: (id) => `الملصق — ${id}`,
    delete_order: 'حذف الطلب؟',
    order_created: 'تم إنشاء الطلب بنجاح!',
    error: 'خطأ',
    invalid_api: 'بيانات API غير صالحة',
    not_configured: 'التكامل غير مُعد',
    invalid_token: 'رمز API غير صالح',
    onboarding_create: 'إنشاء متجري',
    onboarding_step: (n, total) => `الخطوة ${n} من ${total}`,
    onboarding_store_name: 'اسم المتجر',
    onboarding_continue: 'متابعة',
    onboarding_finish: 'إنهاء',
    tab_orders: 'الطلبات',
    tab_labels: 'الملصقات',
    tab_settings: 'الإعدادات',
    tab_sync: 'المزامنة',
    save: 'حفظ',
    cancel: 'إلغاء',
    close: 'إغلاق',
    delete_btn: 'حذف',
    refresh: 'تحديث',
    export: 'تصدير',
    loading: 'جار التحميل…',
    visible: 'ظاهرة',
    hidden: 'مخفية',
    onboarding_stage_create: 'إنشاء متجرك',
    onboarding_stage_domain: 'إعداد النطاق',
    onboarding_stage_options: 'ضبط الخيارات',
    onboarding_stage_ready: 'المتجر جاهز للإطلاق',
  },
};

export const KIOSTORE_SECTIONS_T = {
  fr: {
    prefs_title: 'Préférences boutique',
    prefs_sub: 'Visibilité, identité visuelle et branding',
    seo_title: 'SEO — Référencement',
    seo_sub: 'Titre et description affichés dans les moteurs de recherche',
    social_title: 'Réseaux sociaux',
    social_sub: 'Liens vers vos pages officielles',
    danger_title: 'Zone de danger',
    danger_sub: 'Actions irréversibles sur votre boutique',
    delete_store: 'Supprimer la boutique ?',
    delete_confirm: 'Oui, supprimer',
    locations_title: 'Emplacements de boutique',
    locations_sub: 'Gérez vos points de stockage et de retrait',
    location_add: 'Ajouter un emplacement',
    location_edit: 'Modifier l\'emplacement',
    location_sub: 'Adresse et position GPS',
    cart_internal: 'Panier interne',
    cart_separate: 'Panier séparé',
    gs_activate: 'Activer',
    gs_deactivate: 'Désactiver',
    lang_label: 'Langue de la boutique',
    lang_desc: 'Choisissez la langue principale utilisée sur la vitrine.',
  },
  en: {
    prefs_title: 'Store preferences',
    prefs_sub: 'Visibility, visual identity and branding',
    seo_title: 'SEO',
    seo_sub: 'Title and description shown in search engines',
    social_title: 'Social networks',
    social_sub: 'Links to your official pages',
    danger_title: 'Danger zone',
    danger_sub: 'Irreversible actions on your store',
    delete_store: 'Delete store?',
    delete_confirm: 'Yes, delete',
    locations_title: 'Store locations',
    locations_sub: 'Manage pickup and storage points',
    location_add: 'Add location',
    location_edit: 'Edit location',
    location_sub: 'Address and GPS position',
    cart_internal: 'Internal cart',
    cart_separate: 'Separate cart',
    gs_activate: 'Enable',
    gs_deactivate: 'Disable',
    lang_label: 'Store language',
    lang_desc: 'Choose the main language used on the storefront.',
  },
  ar: {
    prefs_title: 'تفضيلات المتجر',
    prefs_sub: 'الظهور والهوية البصرية والعلامة التجارية',
    seo_title: 'تحسين محركات البحث',
    seo_sub: 'العنوان والوصف المعروضان في محركات البحث',
    social_title: 'الشبكات الاجتماعية',
    social_sub: 'روابط صفحاتك الرسمية',
    danger_title: 'منطقة الخطر',
    danger_sub: 'إجراءات لا رجعة فيها على متجرك',
    delete_store: 'حذف المتجر؟',
    delete_confirm: 'نعم، احذف',
    locations_title: 'مواقع المتجر',
    locations_sub: 'إدارة نقاط التخزين والاستلام',
    location_add: 'إضافة موقع',
    location_edit: 'تعديل الموقع',
    location_sub: 'العنوان وموقع GPS',
    cart_internal: 'سلة داخلية',
    cart_separate: 'سلة منفصلة',
    gs_activate: 'تفعيل',
    gs_deactivate: 'تعطيل',
    lang_label: 'لغة المتجر',
    lang_desc: 'اختر اللغة الرئيسية المستخدمة في واجهة المتجر.',
  },
};
